import { Label, Switch, type SwitchProps } from '@heroui/react';

interface FormSwitchProps extends Omit<SwitchProps, 'children'> {
  label: string;
}

export function FormSwitch({ label, ...props }: FormSwitchProps) {
  return (
    <Switch {...props}>
      <Switch.Content>
        <Switch.Control>
          <Switch.Thumb />
        </Switch.Control>
        <Label>{label}</Label>
      </Switch.Content>
    </Switch>
  );
}
